










































































































































































import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import GStudentRecordValueCell from '@/views/GStudentRecord/GStudentRecordValueCell.vue';
import GStudentRecordItemCell from '@/views/GStudentRecord/GStudentRecordItemCell.vue';
import GStudentRecordCompetencyComparison from '@/views/GStudentRecord/GStudentRecordCompetencyComparison.vue';
import { studentModule } from '@/store/modules/entities/student.module';
import { StudentKarte } from '@/models/student/student-karte';
import { Student } from '@/models/student/student';
import { SchoolGroup } from '@/models/school-group/school-group';
import GTopicSubject from '@/components/GTopicSubject.vue';
import { StudentGoodPoint, GoodPointUnitByStudent } from '@/models/student/good-point';
import GTextView from '@/components/GTextView.vue';
import { GPageBase } from '@/mixins';
import { globalModule } from '@/store/modules/global.module';

@Component({
  name: 'GStudentRecordProfile',
  components: { GTextView, GTopicSubject, GStudentRecordItemCell, GStudentRecordValueCell, GStudentRecordCompetencyComparison },
  computed: {},
  methods: {},
})
export default class GStudentRecordProfile extends Mixins(GPageBase) {
  @Prop() studentID: number;

  created() {
    studentModule.fetchSchoolGroups(this.studentID);
    studentModule.fetchGoodPoints(this.studentID);
    studentModule.fetchStudentKarte(this.studentID);
  }

  async mounted() {}

  get student(): Student {
    return studentModule.student;
  }

  get studentKarte(): StudentKarte {
    return studentModule.studentKarte;
  }

  get schoolGroups(): SchoolGroup[] {
    return studentModule.schoolGroups;
  }

  get goodPoints(): StudentGoodPoint[] {
    if (!studentModule.studentGoodPoints || !studentModule.studentGoodPoints.data) {
      return [];
    }
    return studentModule.studentGoodPoints.data;
  }

  // [ 他者視点の強み ]
  // AIGROW2-533 同じ生徒からの評価が複数あった場合でも、強み単位で表示していた（同じ生徒が複数表示）
  // これを生徒単位にまとめる修正
  get goodPointsByStudent(): Map<number, GoodPointUnitByStudent> {
    if (!studentModule.studentGoodPoints || !studentModule.studentGoodPoints.data) {
      return new Map();
    }
    const result: Map<number, GoodPointUnitByStudent> = new Map();
    studentModule.studentGoodPoints.data.forEach((sgp: StudentGoodPoint) => {
      if (!result.has(sgp.evalStudentInfo.userID)) {
        const gpbs = new GoodPointUnitByStudent();
        gpbs.evaluatorType = sgp.evaluatorType;
        gpbs.evalStudentInfo = sgp.evalStudentInfo;
        result.set(sgp.evalStudentInfo.userID, gpbs);
      }
      result.get(sgp.evalStudentInfo.userID).goodPoints.push(sgp.goodPoint);
    });
    return result;
  }

  goToGroupEdit(sGroupID: number) {
    let routeData = this.$router.resolve(`/pages/group-edit/${sGroupID}`);
    window.open(routeData.href, '_self');
  }

  isShowReport(row: any): boolean {
    const { reportURL, simpleReportURL, schoolClass } = row;
    if (reportURL === '' || simpleReportURL === '') {
      return false;
    }
    return this.isShowReportURL(schoolClass.schoolClassID);
  }

  isShowReportURL(schoolClassID: number): boolean {
    if (this.isRoleIgsAdmin || (!this.isOldSchoolYear && (this.isRoleAdmin || this.$store.state.account.isResponsibleSchoolClass(schoolClassID)))) {
      //管理者権限を持っているか、または、自分の編集画面である場合のみ表示
      return true;
    } else {
      return false;
    }
  }

  get isRoleIgsAdmin(): boolean {
    return this.$store.state.account.isRoleIgsAdmin;
  }

  get isRoleAdmin(): boolean {
    return this.$store.state.account.isRoleAdmin;
  }

  get isRoleNormal(): boolean {
    return this.$store.state.account.isRoleNormal;
  }

  get isOldSchoolYear(): boolean {
    return globalModule.isOldSchoolYear;
  }

  get big5CategoryEchartService() {
    return studentModule.big5EchartService;
  }
}
